import Vue from 'vue'
import store from './store'

export const host = process.env.NODE_ENV === 'development' ? 'http://10.10.104.3:88' : ''

import { formatDate, typeUtil } from '@/utils/utils'
import { getCodeTable } from '@/store/local/codeTable'

import config from '@/p.config'

Vue.prototype.$host = host

Vue.prototype.$goRegister = () => {
  if (window.location.host !== 'www.global-suyuan.com') {
    if (process.env.NODE_ENV === 'development') {
      window.open(`http://10.10.104.3:88/#/register`)
    } else {
      window.open(`${window.location.origin}/#/register`)
    }
  } else {
    window.open(`https://home.global-suyuan.com/#/register`)
  }
}

Vue.prototype.$goLogin = () => {
  if (window.location.host !== 'www.global-suyuan.com') {
    if (process.env.NODE_ENV === 'development') {
      window.open(`http://10.10.104.3:88/#/loginpass`)
    } else {
      window.open(`${window.location.origin}/#/loginpass`)
    }
  } else {
    window.open(`https://home.global-suyuan.com/#/loginpass`)
  }
}

Vue.prototype.goTroucePage = pageUrl => {
  let host = window.location.origin
  let arr = ['10.10.104.3', '10.10.104.60', 'test.global-suyuan']
  if (arr.every(item => window.location.origin.indexOf(item) == -1)) {
    host = 'https://home.global-suyuan.com'
  }
  if (process.env.NODE_ENV === 'development') {
    host = config.proxy_url
  }
  let jumpUrl = host
  let path = '/#'
  if (store.state.userInfo.userCategory === 'B') {
    path = '/admin/#'
  }
  jumpUrl = host + path
  if (pageUrl) {
    jumpUrl += pageUrl
  }
  window.open(jumpUrl)
}

Vue.prototype.formatDate = function (value, formatStr) {
  return formatDate(value, formatStr)
}

//显示loading
Vue.prototype.showLoading = function () {
  this.$store.commit('setLoading', true)
}
//隐藏loading
Vue.prototype.hideLoading = function () {
  this.$store.commit('setLoading', false)
}

// 码表值转名
Vue.prototype.codeToName = async (codeConfig, codeValue) => {
  let codeDefId = null
  if (typeUtil.isObject(codeConfig)) {
    let { params = {} } = codeConfig
    codeDefId = params.codeDefId || null
  } else {
    codeDefId = codeConfig
  }
  let arr = codeValue ? codeValue.toString().split(',') : []
  const res = await getCodeTable({ codeDefId })
  let data = (res && res.list && res.list[0] && res.list[0].columnValue) || []
  let item = data.filter(item => {
    return arr.includes(item[0])
  })
  let newArr = item.map(el => {
    return el[1]
  })
  return newArr.length ? newArr.join(',') : codeValue
}

// 获取码表数据
Vue.prototype.$getCodeTable = async codeConfig => {
  let codeDefId = null
  let handler = null
  if (typeUtil.isObject(codeConfig)) {
    let { params = {} } = codeConfig
    codeDefId = params.codeDefId || null
    handler = codeConfig.handler
  } else {
    codeDefId = codeConfig
  }
  const res = await getCodeTable({ codeDefId })
  let data = (res && res.list && res.list[0] && res.list[0].columnValue) || []
  if (typeof handler === 'function') {
    data = handler(data)
  } else {
    data = data.map(item => {
      return {
        value: item[0],
        label: item[1],
        orgData: item,
      }
    })
  }
  return data
}

/*给对象设置默认值*/
Vue.prototype.setDefValue = function (to, from, deep = false) {
  Object.keys(from).forEach(key => {
    if (!to.hasOwnProperty(key)) {
      if (Object.prototype.toString.call(from[key]) === '[object Object]' && deep) {
        this.setDefValue(to[key], from[key], deep)
      } else {
        to[key] = from[key]
      }
    }
  })
}

/*该方法可以将内部组件的方法绑定到当前组件中，以实现方法的传递。elementUI组件二次封装时有用*/
Vue.prototype.bindMethods = function (ref) {
  let refObj = this.$refs[ref]
  for (let key in refObj) {
    if (!(key in this) && typeof refObj[key] === 'function') {
      this[key] = refObj[key].bind(refObj)
    }
  }
}

  // 深拷贝对象
  Vue.prototype.deepCopy = function (obj, parent = null) {
    // 创建一个新对象
    if (typeof obj !== 'object') return obj
    let result = {}
    let keys = Object.keys(obj)
    let key = null
    let temp = null
    let _parent = parent
    // 该字段有父级则需要追溯该字段的父级
    while (_parent) {
      // 如果该字段引用了它的父级则为循环引用
      if (_parent.originalParent === obj) {
        // 循环引用直接返回同级的新对象
        return _parent.currentParent
      }
      _parent = _parent.parent
    }
    for (let i = 0; i < keys.length; i++) {
      key = keys[i]
      temp = obj[key]
      // 如果字段的值也是一个对象
      if (temp && typeof temp === 'object') {
        // 递归执行深拷贝 将同级的待拷贝对象与新对象传递给 parent 方便追溯循环引用
        result[key] = this.deepCopy(temp, {
          originalParent: obj,
          currentParent: result,
          parent: parent
        })
      } else {
        result[key] = temp
      }
    }
    if (Array.isArray(obj)) {
      result.length = keys.length
      result = Array.from(result)
    }
    return result
  }
